// extracted by mini-css-extract-plugin
export var iconWrap = "navlink_styles-module--icon-wrap--298fc";
export var navlinkWrap = "navlink_styles-module--navlink-wrap--31096";
export var svg = "navlink_styles-module--svg--ec41a";